// /** Vendor js */
import '../vendor/banner-parallax';

/** Components */
import '../components/custom-select';
import '../components/go-to-anchor';
import '../components/tooltip';
import '../components/circle-graph';
import '../components/definition-tooltip';

/** Modules */
import '../modules/header';
import '../modules/blocks/front-page-hero';
import '../modules/blocks/latest-card-carousel';
import '../modules/blocks/partner-carousel';
import '../modules/blocks/testimonial-carousel';
import '../modules/modal';
import '../modules/blocks/team-grid';
import '../modules/blocks/funder-carousel';
//import '../modules/blocks/workstream-detail';
import '../modules/blocks/anchor';
import '../modules/header';
import '../modules/blocks/workstream-info';
//import '../modules/blocks/program-detail';
import '../modules/blocks/tertiary-header.js';
import '../modules/blocks/google-map';
import '../modules/blocks/wysiwyg';
import '../modules/blocks/company-statement';
import '../modules/blocks/tabbed-content';
import '../modules/blocks/jobs-list';
import '../modules/blocks/video-slider';
import '../modules/blocks/footnote-tooltip';
import '../modules/video-link-shortcode';

/* page */
import '../components/partner';
import '../components/sidebar-filters';
import '../components/custom-select';
import '../components/funder';
import '../components/contact-form';
import '../components/partner-grid';
import '../components/list-color';

/** Partials */
import '../partials/search-results';
import frSticky from '../components/sticky-sidebar';
import '../partials/content-paper';

/** Forms */
//import '../forms/zoom-forms';

/** Templates */
import '../templates/template-partner';

export default {
  init() {
    // JavaScript to be fired on all pages
    // Script for add dots in module
    $('.module.with-dot').prepend(
      '<div class="module-dot parallax-layer" data-parallax-deep="50"></div>'
    );
  },
  finalize() {
    frSticky.init();
    frSticky.initializeSidebarMenu();
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js